import { render, staticRenderFns } from "./givepopup.vue?vue&type=template&id=4897a576&scoped=true"
import script from "./givepopup.vue?vue&type=script&lang=js"
export * from "./givepopup.vue?vue&type=script&lang=js"
import style0 from "./givepopup.vue?vue&type=style&index=0&id=4897a576&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4897a576",
  null
  
)

export default component.exports